import { createSelector } from 'reselect';

export const getGroupIds = (state) => state?.groups?.groupIds;
export const getGroupsById = (state) => state?.groups?.groupsById;

export const selectGroups = createSelector(
  [getGroupIds, getGroupsById],
  (groupIds, groupsById) => {
    return groupIds?.map((id) => {
      const group = groupsById[id] || {};
      return {
        ...group,
        key: group?.uuid,
        label: group?.name,
        value: group?.uuid,
      };
    });
  },
);
